import React, { useState, useEffect } from "react";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import Base from "../admin_components/Admin_Base";
import "../Invoices_Payments/paymenthistory.css";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Breadcrumbs } from "@mui/material";
import { Link } from "react-router-dom";
import { ADMIN_API_BASE_URL } from "../Auth/Api";
import authAxios from "../Auth/useAxios";
import { ClipLoader } from "react-spinners";

const PaymentsHistory = () => {
  const [filterStatus, setFilterStatus] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 24;
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);



  useEffect(() => {
    fetchPaymentHistoryList();
  }, []);

  const fetchPaymentHistoryList = async () => {
    try {
      const response = await authAxios.get(
        `${ADMIN_API_BASE_URL}/main/admin/emis`
      );

      setPayments(response.data);
      console.log(response.data);
    } catch (error) {
      console.error("❌ Error fetching all employees:", error);
    } finally {
      setLoading(false);
    }
  };


  const filteredRequests = payments.filter((request) => {
    if (filterStatus === "all") return request.isPaid === true; // Show only paid records
    return request.isPaid === true && request.status.toLowerCase() === filterStatus.toLowerCase();
  });

  const totalPages = Math.ceil(filteredRequests.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedRequests = filteredRequests.slice(startIndex, endIndex);

  const convertToCSV = (data) => {
    const headers = [
      "S.No",
      "Customer Name",
      "Passbook Number",
      "Property Name",
      "Amount Paid",
      "Date",
      "Status",
    ];

    const rows = data.map((request) => [
      request.sno,
      request.customerName,
      request.passbook,
      request.groupName,
      request.emiAmount,
      request.emiDate,
      request.isPaid ? "Paid" : "Not Paid",
    ]);

    const csvContent = [
      headers.join(","),
      ...rows.map((row) => row.join(",")),
    ].join("\n");

    return csvContent;
  };

  const handleDownload = () => {
    const csvData = convertToCSV(filteredRequests);
    const blob = new Blob([csvData], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "payments_history.csv";
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Base>
      {loading ? (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "300px" }}>
          <ClipLoader color="darkslategrey" size={50} />
        </div>
      ) : error ? (
        <div>{error}</div>
      ) : (
        <>
          <div className="pt-3 mt-5 mb-4" style={{ display: "flex", justifyContent: "flex-end", paddingRight: "20px" }}>
            <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
              <Link to="/admin/dashboard" style={{ color: "darkslategrey", fontWeight: "bold" }}>Dashboard</Link>
              <Link to="/admin/Payments_History" style={{ color: "darkslategrey", fontWeight: "bold" }}>Payments History</Link>
            </Breadcrumbs>
          </div>

          <p className="text-center fw-bold main_heading mb-1">Payments History</p>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <hr style={{ width: "90%" }} />
          </div>

          {/* <div className="payment-button-csv" style={{ textAlign: "end" }}>
        <button onClick={handleDownload} className="download-button-payment-history">Download CSV</button>
      </div> */}

          <div className="download-csv-container" style={{ textAlign: "end" }}>
            <button
              onClick={handleDownload}
              className="download-button-payment-history"
            >
              Download CSV
            </button>
          </div>

          <Table className="responsive-table-wallet customer-table">
            <Thead>
              <Tr>
                <Th>S.No</Th>
                <Th>Customer Name</Th>
                <Th>Passbook Number</Th>
                <Th>Property Name</Th>
                <Th>Amount Paid</Th>
                <Th>Date</Th>
                <Th>Status</Th>
              </Tr>
            </Thead>
            <Tbody>
              {paginatedRequests.map((request, index) => (
                <Tr key={request.sno}>
                  <Td>{(currentPage - 1) * itemsPerPage + index + 1}</Td>
                  <Td>{request.customerName}</Td>
                  <Td>{request.passbook}</Td>
                  <Td>{request.groupName}</Td>
                  <Td>{request.emiAmount}</Td>
                  <Td>{request.emiDate}</Td>
                  <Td>
                    <span
                      className={`status-badge ${request.isPaid ? "paid" : "not paid"}`}
                    >
                      {request.isPaid ? "Paid" : "Not paid"}
                    </span>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>

          <div className="pagination-controls-payment-history">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <span className="mx-2">
              Page {currentPage} of {totalPages}
            </span>
            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </>
      )}
    </Base>
  );
};

export default PaymentsHistory;
